import axios from 'axios'
import store from '~/store'
import router from '~/router'
import Cookies from 'js-cookie'
import swal from 'sweetalert2'
import i18n from '~/plugins/i18n'

// Request interceptor
axios.interceptors.request.use(request => {
  let token = Cookies.get('token')
  
  if (token) {
    request.headers.common['Authorization'] = `Bearer ${token}`
  }

  const locale = store.getters['lang/locale']
  if (locale) {
    request.headers.common['Accept-Language'] = locale
  }

  /*const company = store.getters['auth/company']
  if(company){
    request.headers['Company-Id'] = company.id
  }*/
  // request.headers['X-Socket-Id'] = Echo.socketId()

  return request
})

// Response interceptor
axios.interceptors.response.use(response => response, error => {
  const { status } = error.response

  if (status >= 500) {
    swal({
      type: 'error',
      title: i18n.t('error_alert_title'),
      text: i18n.t('error_alert_text'),
      reverseButtons: true,
      confirmButtonText: i18n.t('ok'),
      cancelButtonText: i18n.t('cancel')
    })
  }

  if (status === 401 && store.getters['auth/check']) {
    swal({
      type: 'warning',
      title: i18n.t('token_expired_alert_title'),
      text: i18n.t('token_expired_alert_text'),
      reverseButtons: true,
      confirmButtonText: i18n.t('ok'),
      cancelButtonText: i18n.t('cancel')
    }).then(() => {
      store.commit('auth/LOGOUT')

      let queryString = window.location.pathname.toString() + window.location.search.toString();

      router.push({ 
        name: 'login',
        query: {
          'redirectTo' : queryString,
        }
      })
    })
  }

  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/axios.js